import ExtensionIcon from '@mui/icons-material/Extension';
import CardsGridSubmenu from '../../../common/components/cardsGrid/cardsGridSubmenu';
import BasicLayout from '../../../common/layouts/basicLayout';
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import { CardsGridItem } from '../../../common/components/cardsGrid/cardsGrid';
import ReceiptIcon from '@mui/icons-material/Receipt';

const cover: CardsGridItem = {
  title: 'Prada',
  icon: ReceiptIcon,
  path: '/integracao',
};

const gridItems: CardsGridItem[] = [
  {
    title: 'RELATÓRIO DE ITENS',
    icon: DriveFileRenameOutlineIcon,
    path: '/integracao/prada/itens',
  },
  {
    title: 'RELATÓRIO DE CUSTEIO',
    icon: DriveFileRenameOutlineIcon,
    path: '/integracao/prada/custeio',
  },
];

const PradaPage = () => {
  return (
    <BasicLayout title={'Prada'} icon={<ExtensionIcon color={'secondary'} />}>
      <CardsGridSubmenu cover={cover} items={gridItems}></CardsGridSubmenu>
    </BasicLayout>
  );
};

export default PradaPage;
